const $config = JSON.parse(localStorage.getItem("$myconfig"));
export const oidcSettings = $config.oidcSettings;
export const request_url = $config.request_url;
export const config = {
  version: $config.version,
  isUat: $config.isUat
};
